import { useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col, Card, Form, Button, Toast } from "react-bootstrap";
import { forgotPasswords } from "../store/slices/auth";
import { useNavigate } from "react-router-dom";
import img12 from "../assets/bgimg.png";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [mobileNumber, setmobileNumber] = useState("");

  const [emailError, setEmailError] = useState("");
  const [mobileNumberError, setmobileNumberError] = useState("");

  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "danger",
  });

  /* Regex */
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileNumberRegex = /^[0-9]{10}$/;


  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = true;

    // Email validation
    if (!email.trim()) {
      setEmailError("Please enter email");
      valid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter valid email");
      valid = false;
    } else {
      setEmailError("");
    }

    // Mobile validation
    if (!mobileNumber.trim()) {
      setmobileNumberError("Please enter mobile number");
      valid = false;
    } else if (!mobileNumberRegex.test(mobileNumber)) {
      setmobileNumberError("Please enter valid 10-digit mobile number");
      valid = false;
    } else {
      setmobileNumberError("");
    }

    if (!valid) return;

    const payload = {
      email,
      mobileNumber,
    };

    try {
      const response = await dispatch(forgotPasswords(payload)).unwrap();

      setToast({
        show: true,
        message: response?.message || "OTP sent successfully",
        bg: "success",
      });

      setTimeout(() => {
        navigate("/verify-otp", {
          state: {
            email,
            phone: mobileNumber,
            type: "forgotPassword",
          },
        });
      }, 1000);
    } catch (error) {
      setToast({
        show: true,
        message: error?.message || "Failed to send OTP",
        bg: "danger",
      });
    }
  };


  return (
    <>
      {/* Toast */}
      <Toast
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        delay={3000}
        autohide
        bg={toast.bg}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 2000 }}
      >
        <Toast.Body className="text-white">
          {toast.message}
        </Toast.Body>
      </Toast>

      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${img12})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={5} md={7} sm={10}>
                <Card className="shadow" style={{ borderRadius: "20px" }}>
                  <Card.Body className="p-4">
                    <h3 className="fw-bold text-center mb-2">
                      Forgot Password
                    </h3>


                    <Form onSubmit={handleSubmit}>
                      {/* Email */}
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            value={email}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEmail(value);

                              if (!value.trim()) {
                                setEmailError("Please enter email");
                              } else if (!emailRegex.test(value)) {
                                setEmailError("Please enter valid email");
                              } else {
                                setEmailError("");
                              }
                            }}
                            placeholder="Enter email"
                            style={{ paddingLeft: "40px" }}
                          />
                        </div>
                        {emailError && (
                          <small className="text-danger">
                            {emailError}
                          </small>
                        )}
                      </Form.Group>


                      <Form.Group className="mb-2">
                        <Form.Label>Mobile Number</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            value={mobileNumber}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "").slice(0, 10);

                              setmobileNumber(value);

                              if (!value.trim()) {
                                setmobileNumberError("Please enter mobile number");
                              } else if (!mobileNumberRegex.test(value)) {
                                setmobileNumberError("Please enter valid 10-digit mobile number");
                              } else {
                                setmobileNumberError("");
                              }
                            }}
                            placeholder="Enter mobile number"
                            style={{ paddingLeft: "40px" }}
                          />
                        </div>

                        {mobileNumberError && (
                          <small className="text-danger">{mobileNumberError}</small>
                        )}
                      </Form.Group>




                      <Button
                        type="submit"
                        className="w-100 mt-3"
                        style={{
                          backgroundColor: "#1e0959",
                          border: "none",
                          borderRadius: "30px",
                        }}
                      >
                        Send OTP
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
